import { atomFamily } from 'jotai-family';
import { atomWithDefault } from 'jotai/utils';
import { IPersonDataModel } from '../../data-models/person.data-model';
import { fetchPerson } from '../queries/MaggieCompanyQueries';

export const personState = atomFamily((personId: number) =>
  atomWithDefault<IPersonDataModel | null | Promise<IPersonDataModel | null>>(() => fetchPerson(personId))
);
